var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed } from 'mobx';
import RefreshCommand from '../commands/authentication/RefreshCommand';
import Cookies, { COOKIE_TYPES } from './Cookies';
var REFRESH_THRESHOLD = 300000;
var TOKEN_CHECK_INTERVAL = 30000;
/**
 *
 */
var Session = /** @class */ (function () {
    function Session() {
        this.locale = 'nl';
    }
    Object.defineProperty(Session.prototype, "hasToken", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return !!this.jwt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "isLoggedIn", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return !!this.jwt && !!this.user;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param reset
     * @return {null|*}
     */
    Session.prototype.getDeeplink = function (reset) {
        if (reset === void 0) { reset = true; }
        var deeplink = null;
        if (this.initialLocation) {
            deeplink = this.initialLocation.pathname + this.initialLocation.search + this.initialLocation.hash;
        }
        if (reset) {
            this.initialLocation = null;
        }
        return deeplink;
    };
    /**
     *
     * @return {null}
     */
    Session.prototype.getJWT = function () {
        return this.jwt;
    };
    /**
     *
     * @param jwt
     * @param skipCookie
     */
    Session.prototype.setJWT = function (jwt, skipCookie) {
        if (skipCookie === void 0) { skipCookie = false; }
        this.jwt = jwt;
        // Store
        if (!skipCookie) {
            jwt ? Cookies.setCookie(COOKIE_TYPES.JWT, jwt) : Cookies.removeCookie(COOKIE_TYPES.JWT);
        }
        this.updateJWTBody();
        if (!!this.jwt) {
            this.startMonitoringJWTToken();
        }
        else {
            // reset user
            this.user = null;
            this.stopMonitoringJWTToken();
        }
    };
    /**
     *
     */
    Session.prototype.updateJWTBody = function () {
        if (this.jwt) {
            var body = this.jwt + '';
            var parts = body.split('.');
            this.jwtBodyRaw = parts[1];
            this.jwtBody = JSON.parse(window.atob(this.jwtBodyRaw));
            console.log('this.jwtBody', JSON.parse(window.atob(this.jwtBodyRaw)));
        }
        else {
            this.jwtBodyRaw = null;
            this.jwtBody = null;
        }
    };
    /**
     *
     */
    Session.prototype.startMonitoringJWTToken = function () {
        var _this = this;
        this.stopMonitoringJWTToken();
        this._tokenCheckInterval = setInterval(function () {
            _this.checkJWTToken();
        }, TOKEN_CHECK_INTERVAL);
        this.checkJWTToken();
    };
    /**
     *
     */
    Session.prototype.stopMonitoringJWTToken = function () {
        clearInterval(this._tokenCheckInterval);
    };
    /**
     *
     */
    Session.prototype.checkJWTToken = function () {
        if (this.expiresSoon()) {
            console.log('Session : jwt token expires soon, refreshing');
            var command = new RefreshCommand();
            command.execute().catch(function (e) { return console.error(e); });
        }
    };
    /**
     *
     * @return {null|boolean}
     */
    Session.prototype.expiresSoon = function () {
        if (!this.jwtBody || !this.jwtBody['exp']) {
            return null;
        }
        var now = new Date();
        var time = (this.jwtBody['exp'] * 1000) - now.getTime();
        console.log('Session: time before expiration', time, new Date(time));
        // When expires within 5 minutes
        return time < REFRESH_THRESHOLD;
    };
    __decorate([
        observable
    ], Session.prototype, "jwt", void 0);
    __decorate([
        observable
    ], Session.prototype, "jwtBody", void 0);
    __decorate([
        observable
    ], Session.prototype, "isInitialized", void 0);
    __decorate([
        observable
    ], Session.prototype, "user", void 0);
    __decorate([
        observable
    ], Session.prototype, "locale", void 0);
    __decorate([
        computed
    ], Session.prototype, "hasToken", null);
    __decorate([
        computed
    ], Session.prototype, "isLoggedIn", null);
    return Session;
}());
var session = new Session();
export default session;
